export const FETCH_RSS_START = 'FETCH_RSS_START';
export const FETCH_RSS_SUCCESS = 'FETCH_RSS_SUCCESS';
export const FETCH_RSS_FAIL = 'FETCH_RSS_FAIL';

export const FETCH_RSS_HISTORY_START = 'FETCH_RSS_HISTORY_START';
export const FETCH_RSS_HISTORY_SUCCESS = 'FETCH_RSS_HISTORY_SUCCESS';
export const FETCH_RSS_HISTORY_FAIL = 'FETCH_RSS_HISTORY_FAIL';
